import {useInjection} from "inversify-react";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {generatePath, useNavigate, useParams} from "react-router-dom";
import {OrderApi, OrderDetailsDto, OrderProductDto, OrderRefundApi} from "../../../api";
import ApiService from "../../../services/apiService";
import {loadingSpin, RoutingPaths} from "../../routing/routingContainer";
import styles from "../orderRefundListContainer.module.less";
import {ColumnsType} from "antd/es/table";
import {CrudTable, nameof} from "digimuth-components/dist";
import OrderRefundForm from "./orderRefundForm";
import {message} from "antd";

export default function OrderRefundFormAddContainer() {
    const apiService = useInjection(ApiService);
    const navigate = useNavigate();
    const {guid} = useParams();
    const inputRef = useRef<any>(null);
    const [orderDetails, setOrderDetails] = useState<OrderDetailsDto | null>(null);

    const columns: ColumnsType<OrderProductDto> = [
        {
            key: nameof<OrderProductDto>("productName"),
            dataIndex: nameof<OrderProductDto>("productName"),
            title: "Produkt"
        },
        {
            key: nameof<OrderProductDto>("unit"),
            dataIndex: nameof<OrderProductDto>("unit"),
            title: "Jednostka"
        },
        {
            key: nameof<OrderProductDto>("unitPrice"),
            dataIndex: nameof<OrderProductDto>("unitPrice"),
            title: "Cena (zł)"
        },
        {
            key: nameof<OrderProductDto>("amount"),
            dataIndex: nameof<OrderProductDto>("amount"),
            title: "Ilość"
        }
    ]

    const fetchOrder = useCallback(async () => {
        if (!guid) return;
        try {
            const response = await apiService.getApi(OrderApi)
                .apiOrderOrderGuidDetailsGet(guid);
            setOrderDetails(response.data);
        } catch (e: any) {
            return e.response?.data;
        }
    }, [apiService, guid]);

    const onSubmit = useCallback(async (value: number | null) => {
        if (!guid) return;

        try {
            await apiService.getApi(OrderRefundApi).apiOrderRefundPost({
                amount: value?.toString(),
                orderGuid: guid
            });
            navigate(generatePath(RoutingPaths.orderDetails.route, {
                id: orderDetails!.id!.toString()
            }));
            message.success(`Pomyślnie dokonano zwrotu środków dla zamówienia ${orderDetails?.orderNumber}`);
        } catch (e: any) {
            message.error(e.response?.data ?? "Wystąpił błąd podczas próby dokonania zwrotu środków za zamówienie");
            return e.response.data;
        }
    }, [apiService, guid]);

    useEffect(() => {
        fetchOrder();
    }, [fetchOrder]);

    if (!guid) return loadingSpin;

    return <div className={styles.content}>
        <div className={styles.title}>
            Dodaj zwrot dla zamówienia: <strong>{orderDetails?.orderNumber}</strong>
        </div>
        <OrderRefundForm
            ref={inputRef}
            onSubmit={onSubmit}
            maxRefund={orderDetails?.orderValue ?? 0}
        />
        <div className={styles.chooseFromListText}>
            lub wybierz z listy produktów
        </div>
        <div className={styles.tableContainer}>
            <CrudTable
                data={orderDetails?.orderProducts ?? []}
                columns={columns}
                onRowClick={record =>
                    inputRef.current.setRefundValue(record.unitPrice! * record.amount!)}
            />
        </div>
    </div>;
}
